const wrapper = "_35swb90ua2";

export { wrapper };
import "./_task.checkbox.style.linaria.module.css";
//# sourceMappingURL=_task.checkbox.style.js.map
